module.exports = __webpack_public_path__ + "img/arrow_right_2.c883d4b6.svg";